/**
 * Машинное описание страницы для поисковиков (schema.org в формате JSON-LD).
 *
 * Закрывающий тег внутри строки оборвал бы сам блок скрипта, поэтому «<» отдаём кодом символа.
 */
export const JsonLd = ({ data }: { data: Record<string, unknown> }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replaceAll('<', '\\u003c') }}
  />
)
